module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAv0lEQVRYR+2YsQ1CMQxEnyeBDjoYhYo5YAFAjMM00EEFTHIoIgXVT3EpguS0kZ8u51McJTCXpC1wrphDRFwcZDjFpVbSHVhUziMilg6zhyD9CogIi2kVV4dS0GQkJKVD6ZBzbZR7KDOUGcoMTTkw3iyTtAGOwNrqnV/8AvYh6QnMfV4XwrUIKspmXXA+5FYElZadgJXPswhvYDdeqK0zfd/UOctyllkxygy17EuH0qGWA639zNA/OjTch1XXL70PlTKYWOXmYkYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wap/open1.png
// module id = TqMp
// module chunks = 1